var $9UOFb$reactariautils = require("@react-aria/utils");
var $9UOFb$reactariai18n = require("@react-aria/i18n");
var $9UOFb$reactariatextfield = require("@react-aria/textfield");
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {
    get: v,
    set: s,
    enumerable: true,
    configurable: true
  });
}
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
$parcel$export(module.exports, "useSearchField", () => $ccae92a71d96d51a$export$9bb30bbe003b82e0);
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /*
    * Copyright 2020 Adobe. All rights reserved.
    * This file is licensed to you under the Apache License, Version 2.0 (the "License");
    * you may not use this file except in compliance with the License. You may obtain a copy
    * of the License at http://www.apache.org/licenses/LICENSE-2.0
    *
    * Unless required by applicable law or agreed to in writing, software distributed under
    * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
    * OF ANY KIND, either express or implied. See the License for the specific language
    * governing permissions and limitations under the License.
    */
var $8e80a08ea739bb00$exports = {};
var $bd6662502a469b02$exports = {};
$bd6662502a469b02$exports = {
  "Clear search": "\u0645\u0633\u062D \u0627\u0644\u0628\u062D\u062B"
};
var $360cd10b99b1ec90$exports = {};
$360cd10b99b1ec90$exports = {
  "Clear search": "\u0418\u0437\u0447\u0438\u0441\u0442\u0432\u0430\u043D\u0435 \u043D\u0430 \u0442\u044A\u0440\u0441\u0435\u043D\u0435"
};
var $ffecf95c9ab0a601$exports = {};
$ffecf95c9ab0a601$exports = {
  "Clear search": "Vymazat hled\xE1n\xED"
};
var $a8c1807afa0c6ad0$exports = {};
$a8c1807afa0c6ad0$exports = {
  "Clear search": "Ryd s\xF8gning"
};
var $0e885ea91b94ae2b$exports = {};
$0e885ea91b94ae2b$exports = {
  "Clear search": "Suche zur\xFCcksetzen"
};
var $a313361aefc92d6a$exports = {};
$a313361aefc92d6a$exports = {
  "Clear search": "\u0391\u03C0\u03B1\u03BB\u03BF\u03B9\u03C6\u03AE \u03B1\u03BD\u03B1\u03B6\u03AE\u03C4\u03B7\u03C3\u03B7\u03C2"
};
var $aca1149af311369c$exports = {};
$aca1149af311369c$exports = {
  "Clear search": "Clear search"
};
var $fcf49eac878c2dd4$exports = {};
$fcf49eac878c2dd4$exports = {
  "Clear search": "Borrar b\xFAsqueda"
};
var $a4cc5fda0ae4bc39$exports = {};
$a4cc5fda0ae4bc39$exports = {
  "Clear search": "T\xFChjenda otsing"
};
var $3490cbf44d66e748$exports = {};
$3490cbf44d66e748$exports = {
  "Clear search": "Tyhjenn\xE4 haku"
};
var $7139336f2276b57b$exports = {};
$7139336f2276b57b$exports = {
  "Clear search": "Effacer la recherche"
};
var $2cfd40eac86ffaf9$exports = {};
$2cfd40eac86ffaf9$exports = {
  "Clear search": "\u05E0\u05E7\u05D4 \u05D7\u05D9\u05E4\u05D5\u05E9"
};
var $ad5cd81fb4b71e02$exports = {};
$ad5cd81fb4b71e02$exports = {
  "Clear search": "Obri\u0161i pretragu"
};
var $efa4f2797ecc2e40$exports = {};
$efa4f2797ecc2e40$exports = {
  "Clear search": "Keres\xE9s t\xF6rl\xE9se"
};
var $7d0d440111d7eb6f$exports = {};
$7d0d440111d7eb6f$exports = {
  "Clear search": "Cancella ricerca"
};
var $15bb9dd1255c87e0$exports = {};
$15bb9dd1255c87e0$exports = {
  "Clear search": "\u691C\u7D22\u3092\u30AF\u30EA\u30A2"
};
var $662038034d042bc2$exports = {};
$662038034d042bc2$exports = {
  "Clear search": "\uAC80\uC0C9 \uC9C0\uC6B0\uAE30"
};
var $469701bdc0ecd008$exports = {};
$469701bdc0ecd008$exports = {
  "Clear search": "I\u0161valyti ie\u0161k\u0105"
};
var $bddb04e2df050d62$exports = {};
$bddb04e2df050d62$exports = {
  "Clear search": "Not\u012Br\u012Bt mekl\u0113\u0161anu"
};
var $a295a578d307d4b5$exports = {};
$a295a578d307d4b5$exports = {
  "Clear search": "T\xF8m s\xF8k"
};
var $e0731003f5c0bbc3$exports = {};
$e0731003f5c0bbc3$exports = {
  "Clear search": "Zoekactie wissen"
};
var $9acaf16c6e495332$exports = {};
$9acaf16c6e495332$exports = {
  "Clear search": "Wyczy\u015B\u0107 zawarto\u015B\u0107 wyszukiwania"
};
var $1087013ecb748501$exports = {};
$1087013ecb748501$exports = {
  "Clear search": "Limpar pesquisa"
};
var $71e9e5edc2bbe98a$exports = {};
$71e9e5edc2bbe98a$exports = {
  "Clear search": "Limpar pesquisa"
};
var $a4bd32ef01b4a9e1$exports = {};
$a4bd32ef01b4a9e1$exports = {
  "Clear search": "\u015Eterge\u0163i c\u0103utarea"
};
var $0807874c8146beee$exports = {};
$0807874c8146beee$exports = {
  "Clear search": "\u041E\u0447\u0438\u0441\u0442\u0438\u0442\u044C \u043F\u043E\u0438\u0441\u043A"
};
var $3ed5a8cd509d389e$exports = {};
$3ed5a8cd509d389e$exports = {
  "Clear search": "Vymaza\u0165 vyh\u013Ead\xE1vanie"
};
var $1cc960210efc0d20$exports = {};
$1cc960210efc0d20$exports = {
  "Clear search": "Po\u010Disti iskanje"
};
var $18a26c027bd07b1a$exports = {};
$18a26c027bd07b1a$exports = {
  "Clear search": "Obri\u0161i pretragu"
};
var $2ca3577ce1438e9b$exports = {};
$2ca3577ce1438e9b$exports = {
  "Clear search": "Rensa s\xF6kning"
};
var $ced44bcac3738390$exports = {};
$ced44bcac3738390$exports = {
  "Clear search": "Aramay\u0131 temizle"
};
var $abd2f08b465610a9$exports = {};
$abd2f08b465610a9$exports = {
  "Clear search": "\u041E\u0447\u0438\u0441\u0442\u0438\u0442\u0438 \u043F\u043E\u0448\u0443\u043A"
};
var $becec37c237a6c53$exports = {};
$becec37c237a6c53$exports = {
  "Clear search": "\u6E05\u9664\u641C\u7D22"
};
var $f7dff162f8d4dac5$exports = {};
$f7dff162f8d4dac5$exports = {
  "Clear search": "\u6E05\u9664\u641C\u5C0B\u689D\u4EF6"
};
$8e80a08ea739bb00$exports = {
  "ar-AE": $bd6662502a469b02$exports,
  "bg-BG": $360cd10b99b1ec90$exports,
  "cs-CZ": $ffecf95c9ab0a601$exports,
  "da-DK": $a8c1807afa0c6ad0$exports,
  "de-DE": $0e885ea91b94ae2b$exports,
  "el-GR": $a313361aefc92d6a$exports,
  "en-US": $aca1149af311369c$exports,
  "es-ES": $fcf49eac878c2dd4$exports,
  "et-EE": $a4cc5fda0ae4bc39$exports,
  "fi-FI": $3490cbf44d66e748$exports,
  "fr-FR": $7139336f2276b57b$exports,
  "he-IL": $2cfd40eac86ffaf9$exports,
  "hr-HR": $ad5cd81fb4b71e02$exports,
  "hu-HU": $efa4f2797ecc2e40$exports,
  "it-IT": $7d0d440111d7eb6f$exports,
  "ja-JP": $15bb9dd1255c87e0$exports,
  "ko-KR": $662038034d042bc2$exports,
  "lt-LT": $469701bdc0ecd008$exports,
  "lv-LV": $bddb04e2df050d62$exports,
  "nb-NO": $a295a578d307d4b5$exports,
  "nl-NL": $e0731003f5c0bbc3$exports,
  "pl-PL": $9acaf16c6e495332$exports,
  "pt-BR": $1087013ecb748501$exports,
  "pt-PT": $71e9e5edc2bbe98a$exports,
  "ro-RO": $a4bd32ef01b4a9e1$exports,
  "ru-RU": $0807874c8146beee$exports,
  "sk-SK": $3ed5a8cd509d389e$exports,
  "sl-SI": $1cc960210efc0d20$exports,
  "sr-SP": $18a26c027bd07b1a$exports,
  "sv-SE": $2ca3577ce1438e9b$exports,
  "tr-TR": $ced44bcac3738390$exports,
  "uk-UA": $abd2f08b465610a9$exports,
  "zh-CN": $becec37c237a6c53$exports,
  "zh-TW": $f7dff162f8d4dac5$exports
};
function $ccae92a71d96d51a$export$9bb30bbe003b82e0(props, state, inputRef) {
  let stringFormatter = (0, $9UOFb$reactariai18n.useLocalizedStringFormatter)((0, /*@__PURE__*/$parcel$interopDefault($8e80a08ea739bb00$exports)));
  let {
    isDisabled: isDisabled,
    isReadOnly: isReadOnly,
    onSubmit = () => {},
    onClear: onClear,
    type = "search"
  } = props;
  let onKeyDown = e => {
    const key = e.key;
    if (key === "Enter" || key === "Escape") e.preventDefault();
    if (isDisabled || isReadOnly) return;
    if (key === "Enter") onSubmit(state.value);
    if (key === "Escape") {
      state.setValue("");
      if (onClear) onClear();
    }
  };
  let onClearButtonClick = () => {
    state.setValue("");
    if (onClear) onClear();
  };
  let onPressStart = () => {
    // this is in PressStart for mobile so that touching the clear button doesn't remove focus from
    // the input and close the keyboard
    inputRef.current.focus();
  };
  let {
    labelProps: labelProps,
    inputProps: inputProps,
    descriptionProps: descriptionProps,
    errorMessageProps: errorMessageProps
  } = (0, $9UOFb$reactariatextfield.useTextField)({
    ...props,
    value: state.value,
    onChange: state.setValue,
    onKeyDown: (0, $9UOFb$reactariautils.chain)(onKeyDown, props.onKeyDown),
    type: type
  }, inputRef);
  return {
    labelProps: labelProps,
    inputProps: {
      ...inputProps,
      // already handled by useSearchFieldState
      defaultValue: undefined
    },
    clearButtonProps: {
      "aria-label": stringFormatter.format("Clear search"),
      excludeFromTabOrder: true,
      // @ts-ignore
      preventFocusOnPress: true,
      isDisabled: isDisabled || isReadOnly,
      onPress: onClearButtonClick,
      onPressStart: onPressStart
    },
    descriptionProps: descriptionProps,
    errorMessageProps: errorMessageProps
  };
}